import { assetsURL } from './activity-config';
export var defaultCardArt = "".concat(assetsURL, "/assets/cardArt/syf_generic_card.svg");
//# sourceMappingURL=defaults.js.map